function verifyTruckIdSmiths(valor) {
    const regexp = /^(19|20|21)\d\d(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])\d\d\d\d\d\d\w\w\w\w$/;
    return regexp.test(valor);
}

function verifyTruckIdNuchtech(valor) {
    const regexp = /\w\w\w\w\w\w\w\w\w(19|20|21)\d\d(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])\d\d\d\d/;
    return regexp.test(valor);
}
module.exports = {
    verifyTruckIdSmiths, verifyTruckIdNuchtech
}